import type { FC } from "react";

import { faTrash } from "@fortawesome/pro-duotone-svg-icons/faTrash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MenuItemButton } from "@styled/menu_item_button";

export const MenuItemButtonDestroy: FC<{
  onClick(): void;
}> = ({ onClick }) => (
  <MenuItemButton onClick={onClick}>
    <FontAwesomeIcon icon={faTrash} /> Delete
  </MenuItemButton>
);
